import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { intersection, isArray, keyBy, keys } from 'lodash';
import { isEmpty, regCompare } from '../../../helpers';
import { TState } from '../../../redux/store';
import { momentTimezone } from '../../utils/dateUtils';

const checkValue = (
  row: Record<string, any>,
  columnId: string,
  filterValue: any,
  type: string,
  value: any,
) => {
  return isEmpty(filterValue)
    ? true
    : /_city|_street|_postal|_dept/.test(columnId)
      ? regCompare(
          `${/_postal/.test(columnId) ? '^' : ''}${filterValue}`,
          value,
          'ig',
        )
      : /number|count/.test(type)
        ? (!filterValue[0] || (value ?? 0) >= filterValue[0]) &&
          (!filterValue[1] || (value ?? 0) <= filterValue[1])
        : /date/.test(type)
          ? (!filterValue[0] ||
              momentTimezone(value).isSameOrAfter(
                momentTimezone(filterValue[0]),
                'date',
              )) &&
            (!filterValue[1] ||
              momentTimezone(value).isSameOrBefore(
                momentTimezone(filterValue[1]),
                'date',
              ))
          : /switch/.test(type)
            ? filterValue
              ? value === true
              : !value
            : isArray(value) && intersection(value, filterValue).length
              ? true
              : isArray(filterValue)
                ? filterValue.includes(value)
                : regCompare(filterValue, value);
};

const useFilters = (json?: boolean) => {
  const dataInputs = useSelector((state: TState) => state.dataInputs);
  const dataInputsById = keyBy(dataInputs, 'name_id');

  const filtersFn = useCallback(
    (cols?: any[]) =>
      (row: Record<string, any>, columnId: string, filterValue: any) => {
        const { type } = dataInputsById[columnId] || {};
        const nbRepeat = keyBy(cols, 'id')[columnId]?.meta?.nbRepeat ?? 0;

        if (nbRepeat) {
          return (
            Array.from({ length: nbRepeat }).filter((_, idx) => {
              const key = `repeat_${columnId}_${idx}`;
              const value = (json ? row : row.original)[key];
              return checkValue(row, key, filterValue, type, value);
            }).length > 0
          );
        } else {
          const value = (json ? row : row.original)[columnId];
          return checkValue(row, columnId, filterValue, type, value);
        }
      },
    [keys(dataInputsById).join('-')],
  );

  return filtersFn;
};

export default useFilters;
